import MenuBuit from './Compartido/MenuBuit.jsx';
import BannerPropiedad from './FichaPropiedad/BannerPropiedad.jsx';
import DatosPropiedad from './FichaPropiedad/DatosPropiedad.jsx';
import "../../../../css/web/bedloop1/styles.css";

const FichaPropiedadBL = (props) => {
    return (
        <main className="bl-iframe">
            <MenuBuit
                idiomas={props.idiomas}
                lang={props.lang}
                config={props.websgrupo}
                ruta={props.ruta}
                destinoslarga={props.destinoslarga}
                meta_titulo={props.meta_titulo}
                meta_descripcion={props.meta_descripcion}
                meta_keywords={props.meta_keywords}
            />
            <BannerPropiedad
                propiedad={props.propiedad}
                ruta={props.ruta}
                lang={props.lang}
            />
            <DatosPropiedad
                propiedad={props.propiedad}
                servicios={props.servicios}
                politicas={props.politicas}
                calendario={props.calendario}
                diasbloqueados={props.diasbloqueados}
                primerdialibre={props.primerdialibre}
                lang={props.lang}
                config={props.config}
                extras={props.extras}
                llegada={props.llegada}
                salida={props.salida}
                adultos={props.adultos}
                ninos={props.ninos}
                bebes={props.bebes}
                configweb={props.websgrupo}
                moneda={props.moneda}
                destino={props.eldestino}
                comentarios={props.comentarios}
                ruta={props.ruta}
                diasbloqueadossolos={props.diasbloqueadossolos}
                diasbloqueadoscal={props.diasbloqueadoscal}
                dondeabrir="iframe"
            />
        </main>
    );
}

export default FichaPropiedadBL;
